import React from 'react'
import { Link } from 'react-router-dom'
import PageHeader from '../components/PageHeader'
import { imageUrl } from '../lib/images'

export default function Involved() {
  return (
    <div>
      <PageHeader
        badge="Donationer, partnerskaber og sponsorater"
        title="Støt os & Bliv involveret"
        subtitle="Din støtte er en direkte investering i børn og unges muligheder, trivsel og fremtid."
        breadcrumb={[{ label: 'Bliv involveret' }]}
      />

      {/* SEKTION 5: STØT OS (Foto: COLOURBOX63509247) */}
      <section className="py-16 sm:py-24 bg-white border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Tekst */}
            <div className="lg:col-span-7 space-y-6">
              <span className="text-xs font-bold uppercase tracking-wider text-[#f39223]">
                Ansvarlighed & gennemsigtighed
              </span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0c304d] tracking-tight">
                Støt os
              </h2>
              <div className="space-y-4 text-neutral-700 text-base sm:text-lg leading-relaxed">
                <p>
                  Når du støtter os – hvad enten det er gennem en donation, projektstøtte, et tilskud eller et sponsorat – skal du kunne være tryg ved, at pengene bliver brugt ansvarligt og med ét klart formål: at skabe bedre muligheder for børn og unge på vejen mod et godt, trygt og meningsfuldt liv.
                </p>
                <p>
                  Vi er en non-profit organisation. Det betyder, at alle midler bliver i organisationen og anvendes til vores almennyttige arbejde. Langt størstedelen går direkte til indsatser for børn og unge. Den del, der ikke går direkte til hjælpearbejdet, bruger vi på at sikre en professionel, effektiv og ansvarlig organisation, så vi kan skabe størst mulig værdi for de midler, vi modtager.
                </p>
                <p className="font-extrabold text-[#0c304d] text-lg sm:text-xl">
                  Din støtte er derfor en investering i børn og unges muligheder, trivsel og fremtid.
                </p>
              </div>

              <div className="pt-2 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <Link
                  to="/kontakt"
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#f39223] hover:bg-[#e08112] text-white font-bold text-base px-7 py-3.5 rounded-full transition-colors shadow-xs"
                >
                  <i className="fa-solid fa-heart" aria-hidden="true" />
                  <span>Kontakt os om støtte og sponsorat</span>
                </Link>
                <a
                  href="tel:25778646"
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-neutral-100 hover:bg-neutral-200 text-[#0c304d] font-semibold text-base px-6 py-3.5 rounded-full transition-colors"
                >
                  <i className="fa-solid fa-phone text-[#f39223]" aria-hidden="true" />
                  <span>Ring 25 77 86 46</span>
                </a>
              </div>
            </div>

            {/* Billede: COLOURBOX63509247 */}
            <div className="lg:col-span-5">
              <div className="rounded-3xl overflow-hidden shadow-xl border-4 border-white bg-neutral-100">
                <img
                  src={imageUrl('/_assets/colourbox63509247.jpg', 'width=800,quality=85,format=auto')}
                  alt="Ung smilende kvinde i vinterjakke udendørs"
                  className="w-full h-[460px] object-cover"
                  width={500}
                  height={460}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SAMARBEJDSMULIGHEDER */}
      <section className="py-16 sm:py-24 bg-[#faf9f6]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center space-y-4 mb-16">
            <span className="text-xs font-bold uppercase tracking-wider text-[#f39223]">
              Samarbejdsmodeller
            </span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-[#0c304d] tracking-tight">
              Flere måder at støtte og samarbejde på
            </h2>
            <p className="text-neutral-600 text-base sm:text-lg">
              Uanset om du repræsenterer en fond, en lokal virksomhed eller ønsker at give et personligt bidrag.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-3xl p-8 border border-neutral-200/90 shadow-2xs space-y-4">
              <div className="w-12 h-12 rounded-xl bg-amber-50 text-[#f39223] flex items-center justify-center text-xl">
                <i className="fa-solid fa-gift" aria-hidden="true" />
              </div>
              <h3 className="text-xl font-bold text-[#0c304d]">
                Donationer & fonde
              </h3>
              <p className="text-neutral-600 text-sm leading-relaxed">
                Støt specifikke projekter, mentorforløb eller fritidsaktiviteter for børn og unge. Midlerne går ubeskåret til formålet.
              </p>
            </div>

            <div className="bg-white rounded-3xl p-8 border border-neutral-200/90 shadow-2xs space-y-4">
              <div className="w-12 h-12 rounded-xl bg-sky-50 text-[#0c304d] flex items-center justify-center text-xl">
                <i className="fa-solid fa-briefcase text-[#f39223]" aria-hidden="true" />
              </div>
              <h3 className="text-xl font-bold text-[#0c304d]">
                Virksomhedssponsorater & CSR
              </h3>
              <p className="text-neutral-600 text-sm leading-relaxed">
                Tag et lokalt socialt ansvar. Tilbyd praktikforløb, småjob eller støt økonomisk som fast erhvervspartner.
              </p>
            </div>

            <div className="bg-white rounded-3xl p-8 border border-neutral-200/90 shadow-2xs space-y-4">
              <div className="w-12 h-12 rounded-xl bg-emerald-50 text-[#0c304d] flex items-center justify-center text-xl">
                <i className="fa-solid fa-handshake-angle text-[#f39223]" aria-hidden="true" />
              </div>
              <h3 className="text-xl font-bold text-[#0c304d]">
                Offentlige partnerskaber
              </h3>
              <p className="text-neutral-600 text-sm leading-relaxed">
                Samarbejde med kommuner, UU-centre og uddannelsesinstitutioner om målrettede helhedsindsatser.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
